$(document).ready(function () {

    var getUserInfoDef = $.Deferred();
    function getUserInfoDefDone(status, option) {
        getUserInfoDef.resolve(option, status);
    }

    //用户行为记录
    window.getUserInfoDone = function (status) {

    };
    var userRecord = function (opt) {

        //设置mediaSources
        var usrMediaSources = common.getUrlPara ('mediasources');
        if(usrMediaSources){
            common.setCookie('mediasources', usrMediaSources);
        }

        var sid = common.getUrlPara ('sid');
        if(sid){
            common.setCookie('sid', sid);
        }

        // cookie授权
        var ifCookie = common.getCookie('ifCookie');

        var options = {
            category1: window.cateData.pageIndustryName,
            category2: '',
            category3: '',
            title: '',
            module: '',
            tag: '',
            storeName: '', // 商家名称
            enterpriseName: '', //页面入口
            cookieId: common.getGlobalUserId(),
            equipment: client.browseInfo.equipment,
            browser: client.browseInfo.browser,
            platform: client.browseInfo.os,
            linkSource: document.referrer,
            url: location.href,
            behaviorResult: '浏览成功',
            behaviorType: '浏览网页',
            // behaviorCreatTime: '',//后端生成
            mediaSources: common.getCookie('mbMediaSource') || '',
            sid: common.getCookie('sid') || '',
            ip: client.ip,
            ifCookie: ifCookie || '是',
            client: common.isM?'手机端':'电脑端',
            linkSourceModule: common.getCookie('linkSourceModule_pvar') || '', //页面来源栏目模块（行为数据)
            utmSource: common_utmObj.utm_source,
            utmMedium: common_utmObj.utm_medium,
            utmCampaign: common_utmObj.utm_campaign,
            utmContent: common_utmObj.utm_content,
            utmTerm: common_utmObj.utm_term
        };

        options.category1 = window.cateData.userRecordOption.category1;
        options.category2 = window.cateData.userRecordOption.category2;
        options.category3 = window.cateData.userRecordOption.category3;
        options.title = window.cateData.userRecordOption.title;
        options.module = window.cateData.userRecordOption.module;
        options.tag = window.cateData.userRecordOption.tag;
        options.storeName =  window.cateData.userRecordOption.storeName;
        options.behaviorType = window.cateData.userRecordOption.behaviorType;
        options.behaviorResult = window.cateData.userRecordOption.behaviorResult;


        var parsOptions = common.extend(options, getUserInfo.options);
        parsOptions = common.extend(options, opt);

        var url = window.cateData.userActionUrl;

        try {
            gio('visitor.set', {'cookieID':common.getGlobalUserId()}); //GIO 访问用户变量上传
        }catch (e) {
            console.log('gio visitor.set error', e);
        }

        try {
            var gioParams = {
                module_pvar: parsOptions.module || '',
                category1_pvar: parsOptions.category1 || '',
                category2_pvar: parsOptions.category2 ||  '',
                category3_pvar: parsOptions.category3 ||  '',
                title_pvar: parsOptions.title || '',
                url_pvar: parsOptions.url || '',
                mediaSources_pvar: common.getCookie('mediasources') || '',
                sid_pvar: parsOptions.sid? parsOptions.sid : '',
                linkSource_pvar: parsOptions.linkSource || '',
                behaviorType_pvar: parsOptions.behaviorType || '',
                behaviorResult_pvar: parsOptions.behaviorResult || '',

                linkSourceModule_pvar: common.getCookie('linkSourceModule_pvar') || '', //页面来源栏目模块（行为数据)
                linkSourceCategory1_pvar: common.getCookie('linkSourceCategory1_pvar') || '', //页面来源二级分类（行为数据）
                linkSourceTitle_pvar:  common.getCookie('linkSourceTitle_pvar') || '', //页面来源title（行为数据）

                contentID_pvar: window.cateData.userRecordOption.contentID_pvar || '', //内容ID  商城商品和产品中的商品可能是同一个，该id用于关联这两个相同的产品，！！！暂时不用！！！
                author_pvar: '', //作者 解决方案、案例智库等带作者的页面
                tag_pvar: '', //标签
                tagID_pvar: '', //标签ID
                productModel:  common.getGIOValue('data-gio-product-name') || '', // 产品名称
                eshop_Productnumber_cms: common.getGIOValue('data-gio-product-type') || '', // 产品型号
                productID_pvar: common.getGIOValue('data-gio-product-id') || '', //产品ID 商城、产品中心、产品评测等带有产品的页面
                linkRecommendPosition_pvar: common.getUrlPara('recommendPosition') || '', //来源推荐位区域 热门文章 案例智库 您可能感兴趣 解决方案 相关资料 相关文章 产品中心 市场活动 成功案例 相关资讯 了解详情 会议活动
                linkSearchWord_pvar: common.getUrlPara('search') || '', //来源的搜索词
                shopname_pvar: window.cateData.page.store_name, //所属商户
                triggerReason_var: window.cateData.userRecordOption ? window.cateData.userRecordOption.triggerReason_var : '', //触发原因
                closeType_var: window.cateData.userRecordOption.closeType_var || '', //关闭类型

            };
            // console.log(gioParams);
            gio('page.set', gioParams)
            // console.log('GIO页面级变量设置 gio page.set', gioParams);
            gio('evar.set', {'moduleName_last_evar': gioParams.module_pvar, 'moduleName_linear_evar':gioParams.module_pvar});
            gio('evar.set', {'category1_last_evar': gioParams.category1_pvar, 'category1_linear_evar':gioParams.category1_pvar});
            gio('evar.set', {'title_linear_evar': document.title, 'title_last_evar':document.title});
            common.setCookie('linkSourceModule_pvar', gioParams.module_pvar);
            common.setCookie('linkSourceCategory1_pvar', gioParams.category1_pvar);
            common.setCookie('linkSourceTitle_pvar', gioParams.title_pvar);
        }catch (e) {
            console.log('pc userRecord js gio error',e);
        }

        // 未登录，并且点击拒绝授权cookie
        if (!common.isLogin() && ifCookie == '否') {
            return;
        }
        // 已登录，点击拒绝授权cookie,把cookieId清空
        if (common.isLogin() && ifCookie == '否') {
            parsOptions.cookieId = '';
            parsOptions.globalUserId = '';
        }
        // 已登录，传递session、ocsessid
        if (common.isLogin()) {
            parsOptions.session = common.isLogin().session;
            parsOptions.OCSESSID = common.isLogin().OCSESSID;
        }

        if(location.href.indexOf('//eshop') > -1) {
            // 正式环境才提交行为记录
            postJson(url, parsOptions, function (data) {});
        }else{
            console.log('测试环境行为记录参数，仅展示不提交', parsOptions)
        }
    };

// 用户信息获取
    var getUserInfo = {
        options: {
            globalUserId: '',
            cookieId: '',
            userId: '',
            openId: '',
            unionId: '',
            email: '',
            mobile: '',
            name: '',
            areaCode: '',
            companyPhone: '',
            extension: '',
            enterpriseName: '',
            department: '',
            position: '',
            province: '',
            address: '',
            industry: '',
            companyNum: '',
            ifWish: '',
            privacyNotice: ''
        },

        userFormData: null,

        //获取globalUserId
        globalUserId: function () {
            this.options.globalUserId = common.getGlobalUserId();
            this.getContactId();
            this.getUserId();
        },

        // 获取访问用户组别信息 0组 1组
        getUserTeam: function(){
            return 1
        },

        // 获取联系人ID
        getContactId: function () {
            var _this = this;
            //
            var contactCookieName = 'dell_contactId_' + md5(common.getGlobalUserId());

            // 从cookie中获取联系人ID
            if(common.getCookie(contactCookieName)){
                _this.options.contactId = common.getCookie(contactCookieName);
            }else{
                common.getJson(window.cateData.api.getContactIdUrl, {'cookieId': common.getGlobalUserId()}, function (data) {
                    if(data.errCode === 0){
                        var contactId = data.data.contactId;
                        if(!contactId) return;
                        common.setCookie(contactCookieName, contactId, 5);
                        _this.options.contactId = contactId
                    }
                });
            }
        },

        //获取用户ID
        getUserId: function () {
            var _this = this;

            if (!common.isLogin()) {
                _this.options = {globalUserId: _this.options.globalUserId}
                userRecord(_this.options);
                //构子函数
                getUserInfoDone(false);
                getUserInfoDefDone(false, _this.options);
                return;
            }

            var info = {
                tenantId: window.cateData.tenantId,
                sess:  common.isLogin().session || '',
            };
            var getUrl = window.cateData.api.getUserId;

            common.postJson(getUrl, info, function (data) {
                var ids = data.body.content;

                _this.options.cookieId = ids["cookieId"] ? ids["cookieId"] : '';
                _this.options.userId = ids["loginId"] ? ids["loginId"] : '';
                _this.options.openId = ids["openId"] ? ids["openId"] : '';
                _this.options.unionId = ids["unionId"] ? ids["unionId"] : '';
                _this.getUserInfo();
            });
        },

        //获取用户信息
        getUserInfo: function () {
            var _this = this;
            var info = {
                globalUserId: common.getGlobalUserId(),
                sess: common.isLogin().session || '',
            };

            var getUrl = window.cateData.api.getUserInfo;
            common.postJson(getUrl, info, function (data) {

                if (data.body.result === 0) {
                    var d2_rs = {};
                    data.body.content.forEach(function (item) {
                        d2_rs[item.key] = item.value;
                    });
                    _this.userFormData = data.body.content;
                    _this.options.email = d2_rs["email"] ? d2_rs["email"] : '';
                    _this.options.mobile = d2_rs["mobile"] ? d2_rs["mobile"] : '';
                    _this.options.name = d2_rs["name"] ? d2_rs["name"] : '';
                    _this.options.areaCode = d2_rs["areacode"] ? d2_rs["areacode"] : '';
                    _this.options.companyPhone = d2_rs["compphone"] ? d2_rs["compphone"] : '';
                    _this.options.extension = d2_rs["ext"] ? d2_rs["ext"] : '';
                    _this.options.enterpriseName = d2_rs["enterprise_name"] ? d2_rs["enterprise_name"] : '';
                    _this.options.department = d2_rs["department"] ? d2_rs["department"].toString() : "";
                    _this.options.position = d2_rs["position"] ? d2_rs["position"].toString() : "";
                    _this.options.province = d2_rs['province'] ? d2_rs['province'].toString() : '';
                    _this.options.address = d2_rs['address'] ? d2_rs['address'] : '';
                    _this.options.industry = d2_rs['industry'] ? d2_rs['industry'].toString() : '';
                    _this.options.companyNum = d2_rs['employeesNumber'] ? d2_rs['employeesNumber'].toString() : '';
                    _this.options.ifWish = d2_rs['ifWish'] ? d2_rs['ifWish'].toString() : '';
                    _this.options.privacyNotice = d2_rs['privacynotice'] ? d2_rs['privacynotice'].toString() : '';
                    _this.options.userGroup = d2_rs['userGroup'] ? d2_rs['userGroup'] : ''; // 注册信息中的分组字段

                    userRecord(_this.options);

                    //构子函数
                    getUserInfoDone(true);
                    getUserInfoDefDone(false, _this.options);
                    //gio触发
                    gio('setUserId', _this.options.userId);
                    var gioParams = {
                        // userName_ppl: _this.options.name,
                        // companyName_ppl: _this.options.enterpriseName,
                        // industry_ppl: _this.options.industry,
                        // companyScale_ppl: _this.options.companyNum,
                        // userRole_ppl: _this.options.position,
                        // area_ppl: _this.options.province,
                        // email_ppl: _this.options.email,
                        phone_ppl: common.mobileEncryption(_this.options.mobile),
                    };
                    gio('people.set',gioParams);
                } else {
                    // 用户认证失败删除相应cookie
                    delCookie('smarketMember_' + window.cateData.schemaId);
                    delCookie('globalUserId');
                    //构子函数
                    getUserInfoDone(false);
                    getUserInfoDefDone(false, _this.options);
                    userRecord(_this.options);
                }
            })
        },

        init: function () {
            //获取globalUserId
            this.globalUserId();
        }
    };


//客户端信息获取
    var client = {
        ip: '',
        browser: {
            version: '',
            name: '',
        },
        browseInfo: {
            userAgent: '',
            browser: '',
            version: '',
            os: '',
            equipment: '',
            resolution: '',
            referenceUrl: '',
            referenceTitle: '',
            type: '' //pc、wap
        },
        os: {
            name: '',
        },
        screen: {
            width: window.screen.width,
            height: window.screen.height,
            resolution: window.screen.width + ' * ' + window.screen.height,
        },

        getBrowseInfo: function () {
            var ua, liulanqi, banben, os, equipment, isEdge, isSafari, isChrome, isFirefox, isOpera, isIE, isBrowser,
                isAndroid, isWe, isIPhones, isIPad, isVersion, isWeChat;
            ua = navigator.userAgent;
            liulanqi = '';
            banben = '';
            os = '';
            equipment = '';
            isEdge = ua.match(/(Edge)\/([\d.]+)/i);
            isSafari = ua.match(/Version\/([\d.]+)\s+?(Safari)/i);
            isChrome = ua.match(/(Chrome)\/([\d.]+)/i);
            isFirefox = ua.match(/(Firefox)\/([\d.]+)/i);
            isOpera = ua.match(/(OPR|OPERA).+?([\d.]+)/i);
            isIE = ua.indexOf('Trident') > -1 ||
                ua.toLocaleLowerCase().indexOf('msie') > -1;
            isBrowser = ua.match(/(\w+Browser)[^\d]+?([\d.]+)/i) ||
                ua.match(/\d\s+?([^\d]+)([\d.]+)$/i);
            isAndroid = ua.match(/(Android[\s\d.]+);.+?([^;]+)Build/i);
            isWe = ua.match(/MicroMessenger.+?([\d.]+)/i);
            isIPhones = ua.match(/CPU([\s\w\d_]+)like/i);
            isIPad = ua.match(/iPad/i) ? 'iPad' : 'iPhone';
            isVersion = ua.match(/Version\/([\d.]+)/i);
            isWeChat = isWe;

            //如果是移动端
            if (!!ua.match(/AppleWebKit.*Mobile.*/)) {
                if (isWe) {
                    liulanqi = '微信';
                    banben = isWe[1];
                } else {
                    if (isBrowser) {
                        liulanqi = isBrowser[1];
                        banben = isBrowser[2];
                        if (liulanqi.indexOf('Browser') === -1 && isVersion) {
                            banben = isVersion[1];
                        }
                    } else {
                        liulanqi = '手持设备浏览器';
                        banben = '未知';
                    }
                }
                if (isAndroid) {
                    os = isAndroid[1];
                    equipment = isAndroid[2];
                } else {
                    if (isIPhones) {
                        os = isIPhones[1];
                    } else {
                        os = isIPad;
                    }
                    equipment = isIPad;
                }
                this.browseInfo.type = 'wap';
            } else {
                if (isSafari) {
                    liulanqi = isSafari[2];
                    banben = isSafari[1];
                }
                if (isChrome) {
                    liulanqi = isChrome[1];
                    banben = isChrome[2];
                }
                if (isFirefox) {
                    liulanqi = isFirefox[1];
                    banben = isFirefox[2];
                }
                if (isEdge) {
                    liulanqi = isEdge[1];
                    banben = isEdge[2];
                }
                if (isOpera) {
                    liulanqi = 'OPERA';
                    banben = isOpera[2];
                }

                if (isIE) {
                    liulanqi = 'IE';
                    var isIEV01 = ua.match(/(MSIE).+?(\d+)/i);
                    var isIEV02 = ua.match(/(rv).+?(\d+)/i);
                    if (isIEV01) {
                        banben = isIEV01[2];
                    }
                    if (isIEV02) {
                        banben = isIEV02[2];
                    }
                }
                os = ua.match(/windows/i) ? 'Windows' : 'Mac OS';
                equipment = '电脑端';
                this.browseInfo.type = 'pc';
            }
            this.browseInfo.userAgent = ua;
            this.browseInfo.browser = liulanqi;
            this.browseInfo.version = banben;
            this.browseInfo.os = os;
            this.browseInfo.equipment = equipment;
            this.browseInfo.resolution = window.screen.width + 'X' + window.screen.height;
            this.browseInfo.referenceUrl = document.referrer || '';
            this.browseInfo.referenceTitle = '';
        },

        getIp: function () {
            var _this = this;
            $.ajax({
                url: '//s2-api.smarket.net.cn/cityjson',
                dataType: "script",
                success: function () {
                    _this.ip = returnCitySN.cip;
                    getUserInfo.init();
                },
                error: function () {
                    _this.ip = '127.0.0.1';
                    getUserInfo.init();
                }
            });
        },

        init: function () {
            this.getIp();
            this.getBrowseInfo();
        }
    };
    client.init();
    window.client = client;
    window.getUserInfo = getUserInfo;
    window.userRecord = userRecord;
    window.getUserInfoDef = getUserInfoDef;

    // 商城行为记录
    var userAction = {
        title: window.cateData.userRecordOption.title,
        // 登录
        login: function () {
            userRecord({'behaviorType':'登录', 'behaviorResult':'登录成功'});
        },
        // 退出
        logOut:function () {
            userRecord({'behaviorType':'退出登录', 'behaviorResult':'退出成功'});
        },
        // 注册
        register: function () {
            userRecord({'behaviorType':'注册', 'behaviorResult':''});
        },
        // 在线客服点击
        onlineCustomer: function () {
            userRecord({'behaviorType':'在线客服点击', 'behaviorResult': this.title});
        },
        // 400点击
        customerPhone: function (name) {
            name = name ? name : this.title;
            userRecord({'behaviorType':'400点击', 'behaviorResult':name})
        },
        // 侧边导航点击
        navView: function (name) {
            userRecord({'behaviorType':'查看导航', 'behaviorResult':name});
        },
        // 列表页-选择分类
        chooseCategory: function (name){
            userRecord({'behaviorType':'选择分类', 'behaviorResult':name});
        },
        // 列表页-点击筛选词
        filterProduct: function (name) {
            userRecord({'behaviorType':'筛选商品参数', 'behaviorResult':name});
        },
        // 加入购物车
        addCart: function (name) {
            userRecord({'behaviorType':'加入采购清单', 'behaviorResult':name + ' 加入采购清单'});
        },
        // 加入收藏
        addFavorites: function (name) {
            userRecord({'behaviorType':'收藏', 'behaviorResult':name});
        },
        // 取消收藏
        removeFavorites: function (name) {
            userRecord({'behaviorType':'取消收藏', 'behaviorResult':name});
        },
        // 加入对比
        addCompare: function (name) {
            userRecord({'behaviorType':'加入对比', 'behaviorResult':name + ' 加入对比'});
        },
        // 移除对比
        delCompare: function (name) {
            userRecord({'behaviorType':'移除对比', 'behaviorResult':name + ' 移除对比'});
        },
        // 排序
        sort: function (type) {
            var name = type;
            if(type.options){
                name = type.options[type.selectedIndex].text;
            }
            console.log({'behaviorType':'排序', 'behaviorResult':name})
            userRecord({'behaviorType':'排序', 'behaviorResult':name});
        },
        // 分享
        share:function (name) {
            userRecord({'behaviorType':'分享', 'behaviorResult':name});
        },
        // 产品详情页-点击商品咨询
        advisory: function (name) {
            userRecord({'behaviorType':'企业咨询点击', 'behaviorResult':name});
        },
        // 产品详情页-产品选型
        chooseModel: function (name) {
            userRecord({'behaviorType':'产品选型', 'behaviorResult':name});
        },
        // 产品详情页-一键生成报价单，销售即刻与您联系
        getQuote: function (name, isOfficial) {
            var type = isOfficial != '1' ? '立即购买' : '一键生成报价单';
            userRecord({'behaviorType': type, 'behaviorResult':name});
        },
        // 产品详情页-店铺咨询
        openCustomerService: function (name) {
            userRecord({'behaviorType':'店铺咨询', 'behaviorResult':name});
        },
        // 产品详情页-播放视频
        playProductVideo: function () {
            userRecord({'behaviorType':'播放产品视频', 'behaviorResult':'播放成功'});
        },
        // 产品详情页-提交产品咨询
        subInquiry: function () {
            userRecord({'behaviorType':'企业咨询提交', 'behaviorResult':'成功提交'});
        },
        // 购物车-全选商品
        cartSelectAll: function (storeId, checked) {
            // 获取所有该店铺的商品
            var allProductsName = $('label[data-storeId='+storeId+']').map(function () {
                return $(this).attr('data-productName');
            }).get().join(',');
            if(checked){
                userRecord({'behaviorType':'全选商品', 'behaviorResult':allProductsName});
            }else{
                userRecord({'behaviorType':'取消全选商品', 'behaviorResult':allProductsName});
            }
        },
        // 购物车-单选
        cartSelectSingle: function(productName, checked){
            if(checked){
                userRecord({'behaviorType':'单独勾选商品', 'behaviorResult':productName});
            }else{
                userRecord({'behaviorType':'取消选商品', 'behaviorResult':productName});
            }
        },
        // 购物车-加数量
        cartNumberAdd: function(result){
            userRecord({'behaviorType':'增加商品数量', 'behaviorResult':result});
        },
        // 购物车-减数量
        cartNumberReduce: function(result){
            userRecord({'behaviorType':'减少商品数量', 'behaviorResult':result});
        },
        // 购物车-删除商品
        cartDeleteProduct: function(result){
            userRecord({'behaviorType':'移除商品', 'behaviorResult':result});
        },
        // 订单结算-选择支付方式
        paymentMethod: function(name){
            // userRecord({'behaviorType':'选择支付方式', 'behaviorResult':name});
        },
        // 订单结算-选择配送方式
        shippingMethod: function(name){
            userRecord({'behaviorType':'选择配送方式', 'behaviorResult':name});
        },
        // 订单结算-添加新地址
        addNewAdd: function(add){
            userRecord({'behaviorType':'添加新地址', 'behaviorResult':add});
        },
        // 订单结算-编辑当前地址
        editAdd: function(add){
            userRecord({'behaviorType':'编辑当前地址', 'behaviorResult':add});
        },
        // 订单结算-订单留言
        orderComment: function(commnet){
            userRecord({'behaviorType':'订单留言', 'behaviorResult':commnet});
        },
        // 订单结算-查看使用条款
        viewTerms: function(){
            userRecord({'behaviorType':'查看使用条款', 'behaviorResult':'查看成功'});
        },
        // 订单结算-所有地址展开
        showAlladd: function(){
            userRecord({'behaviorType':'所有地址展开', 'behaviorResult':'展开成功'});
        },

        //订单提交成功页-继续
        orderContinue: function () {
            userRecord({'behaviorType':'继续', 'behaviorResult':'跳转成功'});
        },

        // 对比-移除
        comparedRemove: function (productName) {
            userRecord({'behaviorType':'对比移除', 'behaviorResult':productName});
        },
        // 对比-移除
        comparedAddCart: function (productName) {
            userRecord({'behaviorType':'对比加购', 'behaviorResult':productName});
        },

        // 搜索-搜索
        search: function (key) {
            userRecord({'behaviorType':'搜索', 'behaviorResult':key});
        },

        // 联系我们 -查看地图
        lookMap: function () {
            userRecord({'behaviorType':'查看地图', 'behaviorResult':'跳转成功'});
        },
        // 联系我们 -提交
        contactSubmit: function () {
            userRecord({'behaviorType':'联系我们提交', 'behaviorResult':'提交成功'});
        },
        orderCategorySelect: function (cateName) {
            userRecord({'behaviorType':'选择订单分类', 'behaviorResult': cateName});
        },
        orderPay: function (order_sn, storeName) {
            userRecord({'behaviorType':'立即支付', 'behaviorResult': order_sn, 'storeName': storeName});
        },
        orderShowDetail: function (order_sn,storeName){
            userRecord({'behaviorType':'查看订单详情', 'behaviorResult': order_sn + '订单详情查看成功', 'storeName': storeName});
        },
        orderCancel: function (order_sn, storeName){
            userRecord({'behaviorType':'取消订单', 'behaviorResult': order_sn, 'storeName': storeName});
        },
        orderCancelSuccess: function (){
            userRecord({'behaviorType':'取消订单', 'behaviorResult': "取消订单成功"});
        },
        orderConfirm: function (order_sn, storeName){
            userRecord({'behaviorType':'确认收货', 'behaviorResult': order_sn, 'storeName': storeName});
        },

        // 购物车 -去支付
        toPay: function (name, storeName) {
            if (storeName){
                userRecord({'behaviorType':'立即支付', 'behaviorResult': name, 'storeName': storeName});
            }else{
                userRecord({'behaviorType':'立即支付', 'behaviorResult': name});
            }
        },
        // -使用优惠券
        chooseCoupon: function () {
            userRecord({'behaviorType':'选择优券', 'behaviorResult': '选择优惠券成功'});
        },
        // 查看订单详情
        viewOrderDetail: function (name) {
            userRecord({'behaviorType':'查看订单详情', 'behaviorResult': name});
        },
        // 申请退款
        applyRefund: function (name, storeName) {
            userRecord({'behaviorType':'申请退款', 'behaviorResult': name, 'storeName': storeName});
        },
        // 删除订单
        deleteOrder: function (name, storeName) {
            userRecord({'behaviorType':'删除订单', 'behaviorResult': name, 'storeName': storeName});
        },

        // 兴趣标签选择
        interestTagSelect: function (tags) {
            userRecord({'behaviorType':'选择用户标签', 'behaviorResult': tags});
        },

        // 点击“3D展示”按钮时记录
        viewThreeBtn: function (productName) {
            userRecord({'behaviorType':'3D展示', 'behaviorResult': productName});
        }

    };
    window.userAction = userAction;
});
